import axios, { AxiosResponse } from 'axios';

import { API_ENDPOINTS } from 'Constants';
import DefaultPricingEntity, { IDefaultPricingEntityAttributes } from 'Models/Entities/DefaultPricingEntity';
import { IPriceEntityAttributes } from 'Models/Entities/PriceEntity';

export interface CreateDefaultPricingRequest {
	name: string;
	routeId?: string | null;
	userDisplayNameId?: string | null;
	pricingStrategyProfileId: string;
	isDefault: boolean;
	prices: IPriceEntityAttributes[];
}

interface CreateDefaultPricingResponse {
	id: string;
	name: string;
	routeId?: string | null;
	userDisplayNameId?: string | null;
	pricingStrategyProfileId: string;
	isDefault: boolean;
	prices: IPriceEntityAttributes[];
}

export const createDefaultPricing = async (
	data: CreateDefaultPricingRequest,
): Promise<CreateDefaultPricingResponse> => {
	return axios
		.post<
			CreateDefaultPricingRequest,
			AxiosResponse<CreateDefaultPricingResponse>
		>(API_ENDPOINTS.PRICING.POST_CREATE_DEFAULT_PRICING, data)
		.then(res => res.data);
};

export interface UpdateDefaultPricingRequest {
	id: string;
	name: string;
	routeId?: string | null;
	userDisplayNameId?: string | null;
	pricingStrategyProfileId: string;
	isDefault: boolean;
	prices: IPriceEntityAttributes[];
}

export const updateDefaultPricing = async (
	data: UpdateDefaultPricingRequest,
): Promise<CreateDefaultPricingResponse> => {
	return axios
		.put<
			UpdateDefaultPricingRequest,
			AxiosResponse<CreateDefaultPricingResponse>
		>(API_ENDPOINTS.PRICING.PUT_UPDATE_DEFAULT_PRICING(data.id), data)
		.then(res => res.data);
};

export const fetchDefaultPricing = async (id: string): Promise<DefaultPricingEntity> => {
	return axios
		.get<IDefaultPricingEntityAttributes>(API_ENDPOINTS.PRICING.GET_DEFAULT_PRICING(id))
		.then(res => new DefaultPricingEntity(res.data));
};

export const deleteDefaultPricing = async (id: string): Promise<string> => {
	return axios.delete<string>(API_ENDPOINTS.PRICING.DELETE_DEFAULT_PRICING(id)).then(res => res.data);
};

interface ApplyToUsersResponse {
	applied: number;
}

export const applyDefaultPricingToUsers = async (id: string, userIds: string[]): Promise<ApplyToUsersResponse> => {
	return axios
		.post<ApplyToUsersResponse>(`${API_ENDPOINTS.PRICING.GET_DEFAULT_PRICING(id)}/apply-to-users`, { userIds })
		.then(res => res.data);
};
